import React, { PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useHover } from '@/feature/responsive-design/hooks/use-hover';

type DesktopHoverOverlayProps = PropsWithChildren<{
    borderRadius?: number;
}>;

/**
 * Desktop web hover affordance for existing filled pressable components (balance pill, currency
 * without affecting layout or the child's own press handling. The white border treatment is
 * reserved for keyboard focus (see the :focus-visible rule in public/index.css).
 */
export const DesktopHoverOverlay = ({ children, borderRadius = 9999 }: DesktopHoverOverlayProps) => {
    const { hovered, hoverHandlers } = useHover();

    return (
        <View {...hoverHandlers}>
            {children}
            {hovered ? (
                <Box pointerEvents="none" style={[StyleSheet.absoluteFill, styles.wash, { borderRadius }]} />
            ) : null}
        </View>
    );
};

const styles = StyleSheet.create({
    wash: {
        backgroundColor: ds.colorValue.border.strong,
    },
});
